import { render } from "./collapsed-sidebar.vue?vue&type=template&id=c15a78ea"
import script from "./collapsed-sidebar.vue?vue&type=script&lang=js"
export * from "./collapsed-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__